import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Progress } from './ui/progress';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const GamificationCard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_URL}/gamification/my-stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching gamification stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-6 animate-pulse">
        <div className="h-6 bg-slate-200 rounded w-1/3 mb-4"></div>
        <div className="h-4 bg-slate-200 rounded w-full mb-2"></div>
        <div className="h-4 bg-slate-200 rounded w-2/3"></div>
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-lg p-6 text-white">
      {/* Header con nivel y puntos */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-indigo-200 text-sm font-medium">Tu Nivel</p>
          <div className="flex items-center gap-2">
            <span className="text-4xl font-bold">{stats.level}</span>
            <div className="bg-white/20 px-2 py-1 rounded-full">
              <span className="text-sm">{stats.total_points} XP</span>
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-indigo-200 text-sm">Siguiente nivel</p>
          <p className="font-semibold">{stats.next_level_points} XP</p>
        </div>
      </div>

      {/* Barra de progreso */}
      <div className="mb-6">
        <Progress value={stats.progress_to_next_level} className="h-2 bg-white/20" />
        <p className="text-xs text-indigo-200 mt-1 text-right">
          {Math.round(stats.progress_to_next_level)}% para el siguiente nivel
        </p>
      </div>

      {/* Estadísticas */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="text-center">
          <p className="text-2xl font-bold">{stats.stats.lessons_completed}</p>
          <p className="text-xs text-indigo-200">Lecciones</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold">{stats.stats.quizzes_passed}</p>
          <p className="text-xs text-indigo-200">Quizzes</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold">{stats.stats.courses_completed}</p>
          <p className="text-xs text-indigo-200">Cursos</p>
        </div>
      </div>

      {/* Insignias obtenidas */}
      <div>
        <p className="text-sm font-medium mb-2">Insignias ({stats.badges.length}/{stats.all_badges.length})</p>
        <div className="flex flex-wrap gap-2">
          {stats.badges.length > 0 ? (
            stats.badges.map((badge) => (
              <div
                key={badge.id}
                className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center gap-2"
                title={badge.descripcion}
              >
                <span className="text-xl">{badge.icono}</span>
                <span className="text-xs font-medium">{badge.nombre}</span>
              </div>
            ))
          ) : (
            <p className="text-xs text-indigo-200">
              ¡Completa lecciones y quizzes para ganar insignias!
            </p>
          )}
        </div>
      </div>

      {/* Insignias pendientes */}
      {stats.badges.length < stats.all_badges.length && (
        <div className="mt-4 pt-4 border-t border-white/20">
          <p className="text-xs text-indigo-200 mb-2">Próximas insignias</p>
          <div className="flex flex-wrap gap-2">
            {stats.all_badges
              .filter(badge => !stats.badges.find(b => b.id === badge.id))
              .slice(0, 3)
              .map((badge) => (
                <div
                  key={badge.id}
                  className="bg-white/10 rounded-lg px-3 py-2 flex items-center gap-2 opacity-50"
                  title={badge.descripcion}
                >
                  <span className="text-xl grayscale">{badge.icono}</span>
                  <span className="text-xs">{badge.nombre}</span>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default GamificationCard;
